import React from 'react';
import PropTypes from 'prop-types';
import { Optional } from '@honda-canada/design-system-react';

import DealerContactQuickLink from './DealerContactQuickLink';
import { useVariant } from '../../context/VariantContext';
import { contactDealerProviderService } from '../../utils/constants';
import variantsConfig from './variantsConfig';

const DealerContactQuickLinks = ({ dealerCode, serviceBookingUrl }) => {
  const variant = useVariant();
  const { iconColor } = variantsConfig.getVariantConfig(variant);

  return (
    <>
      <Optional when={serviceBookingUrl}>
        <DealerContactQuickLink dealerCode={dealerCode} queryParam={serviceBookingUrl} iconColor={iconColor} />
      </Optional>

      {Array.from(contactDealerProviderService.values()).map(contactService => (
        <DealerContactQuickLink
          key={contactService}
          dealerCode={dealerCode}
          queryParam={contactService}
          iconColor={iconColor}
        />
      ))}
    </>
  );
};
DealerContactQuickLinks.propTypes = {
  dealerCode: PropTypes.string,
  serviceBookingUrl: PropTypes.string,
};

export default DealerContactQuickLinks;
